import React from 'react'
export default function Footer(props) {
  return (
    <footer className="app-footer">
      <span>&copy; {new Date().getFullYear()} Reggora Inc.</span>
      <span className="ml-auto">Powered by <a href="https://www.reggora.com/">Reggora</a></span>
    </footer>
  )
}
